import { v4 as uuidv4 } from "uuid";

export const renameFileWithUUID = (file) => {
    const fileExt = file.name.split(".").pop();
    const newFilename = `${uuidv4()}.${fileExt}`;
    return new File([file], newFilename, { type: file.type });
};
